import { render, staticRenderFns } from "./ActiveAvisoCert.vue?vue&type=template&id=9f03c614&"
import script from "./ActiveAvisoCert.vue?vue&type=script&lang=js&"
export * from "./ActiveAvisoCert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports